import React from 'react';
import { styled } from '@mui/material';
import { TextField } from '@mui/material';
import { Autocomplete } from '@mui/material';
import { CompanyUserInputProps } from './types';

const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
  '& .MuiAutocomplete-inputRoot': {
    fontSize: '0.875rem',
  },
  '& .MuiAutocomplete-listbox': {
    fontSize: '0.875rem',
  },
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-input': {
    padding: '8px',
    fontSize: '0.75rem',
  },
  '& .MuiOutlinedInput-root': {
    padding: '6px',
  },
}));

const CompanyUserInput = ({
  companyId,
  firmUsersEmails,
  inputValue,
  onInputChange,
  onAddEmail,
}: CompanyUserInputProps) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onAddEmail(companyId);
    }
  };

  return (
    <StyledAutocomplete
      freeSolo
      options={firmUsersEmails.filter((email): email is string => email !== undefined)}
      inputValue={inputValue}
      onInputChange={(_event, newInputValue) => onInputChange(companyId, newInputValue)}
      onKeyDown={handleKeyDown}
      renderInput={params => (
        <StyledTextField {...params} placeholder="Write email and press Enter" variant="outlined" />
      )}
    />
  );
};

export default CompanyUserInput;
